import { useQuery } from "@tanstack/react-query";

import { getMachineGroupConfigurationHistory } from "@/api/audit-configuration-history-api";
import { type AuditRecord } from "@/components/diff-view";

export const MACHINE_GROUP_CONFIGURATION_HISTORY_QUERY_KEY = "machine-groups-configuration-history";

export const useMachineGroupConfigurationHistory = (id: string, enabled: boolean) => {
	return useQuery<AuditRecord[]>({
		queryKey: [MACHINE_GROUP_CONFIGURATION_HISTORY_QUERY_KEY, id],
		queryFn: () => getMachineGroupConfigurationHistory(id),
		initialData: [],
		retry: false,
		enabled,
	});
};
